import store from './store';
import { setAnswer } from './common';

//This script is to update the gender theme at the Family Recipes, Diet Customization and upsell pages
export const updateGender = () => {
  if (backEndVars.gender === 'man') {
    setAnswer('bodyClass', 'men-theme');
    store.set('bodyClass', 'men-theme');
  } else {
    setAnswer('bodyClass', 'woman-theme');
    store.set('bodyClass', 'woman-theme');
  }
};
